import { Box, Flex, MantineTheme, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';

type Props = {
  title: string;
  id: string;
  children?: React.ReactNode;
  expanded: boolean;
  onClick?: () => void;
  total: number;
};

export default function NetWorthTableSubCategorySection({
  id,
  onClick,
  title,
  expanded,
  children,
  total,
}: Props) {
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  });

  return (
    <Box data-testid={id}>
      <Flex onClick={onClick} align="center" py="xs" style={{ cursor: 'pointer' }}>
        <Box
          style={(theme: MantineTheme) => ({
            width: 18,
            height: 18,
            backgroundColor: theme.colors.gray[1],
            boxShadow: theme.shadows.sm,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: theme.radius.sm,
          })}
        >
          <IconChevronDown
            size={14}
            color="var(--mantine-color-gray-10)"
            stroke={1.5}
            style={{
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease',
            }}
          />
        </Box>

        <Flex
          justify="space-between"
          align="center"
          style={{ flex: 1, marginLeft: 'var(--mantine-spacing-xs)' }}
        >
          <Text size="sm" fw={600} c="gray.10">
            {title}
          </Text>
          <Text size="sm" fw={600} c="gray.10">
            {formatter.format(total)}
          </Text>
        </Flex>
      </Flex>

      {expanded && (
        <Box
          ml="xxs"
          mb="xxxs"
          style={(theme: MantineTheme) => ({
            position: 'relative',
            paddingLeft: theme.spacing.xxs,
            boxShadow: `inset 0 -20px 0 0 white, inset 1px 0 0 0 ${theme.colors.gray[2]}`,
          })}
        >
          {children}
        </Box>
      )}
    </Box>
  );
}
